export const LOGO =
  "https://ik.imagekit.io/pwxm960evbp/MES-AA/Site_Images/logo_LdmkTP9ua.png";

export const ABOUT_HEADER =
  "https://ik.imagekit.io/pwxm960evbp/tr:h-350,w-550/MES-AA/Site_Images/About/about_DBrbbz4-C.jpg?updatedAt=1628485804492";

export const REGISTRATION_CERTIFICATE =
  "https://ik.imagekit.io/pwxm960evbp/tr:h-600,w-400/MES-AA/Site_Images/About/registration_mcEtHRz3r.jpeg";

export const DEFAULT_MC =
  "https://ik.imagekit.io/pwxm960evbp/tr:h-255,w-245/MES-AA/Site_Images/About/Committee/default-mc_ttHpAvGdL.svg";

export const CONTACT_HEADER =
  "https://ik.imagekit.io/pwxm960evbp/tr:w-600/MES-AA/Site_Images/Contact/contact_RFmxIu1-F.jpg";

export const ADMIN_LOGIN =
  "https://ik.imagekit.io/pwxm960evbp/tr:h-400,w-650/MES-AA/Site_Images/Admin/admin__6szeALB1NG.jpg?updatedAt=1628486787212";

export const EVENT_DEFAULT =
  "https://ik.imagekit.io/pwxm960evbp/tr:h-150,w-150/MES-AA/Site_Images/Admin/admin__6szeALB1NG.jpg?updatedAt=1628486787212";

// Social icons
export const FACEBOOK_LOGO =
  "https://ik.imagekit.io/pwxm960evbp/MES-AA/Site_Images/Social/facebook_UHIlNFerlq.svg?updatedAt=1633428381669";

export const TWITTER_LOGO =
  "https://ik.imagekit.io/pwxm960evbp/MES-AA/Site_Images/Social/twitter_Yec2MEzVj.svg?updatedAt=1633428381613";

export const INSTAGRAM_LOGO =
  "https://ik.imagekit.io/pwxm960evbp/MES-AA/Site_Images/Social/instagram_x7GpT7Fg4.svg?updatedAt=1633428381584";

export const YOUTUBE_LOGO =
  "https://ik.imagekit.io/pwxm960evbp/MES-AA/Site_Images/Social/youtube_AOusjO5KQ37r.svg?updatedAt=1633428381628";
